import React, { useState } from 'react';
import {ChevronDown} from "lucide-react";

const VoiceDropdown = ({ seriesData, voices, onSelectOption }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    const selectOption = (option) => {
        onSelectOption(option);
        setIsDropdownOpen(false);
        // setSelectedVoiceId(voice.id);
    };
   return <div className="relative">
       <button
           onClick={toggleDropdown}
           className="w-full p-2 border border-gray-300 rounded-lg bg-white text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
       >
           <span>{seriesData.voice?.name || "Select a voice"}</span>
           <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${isDropdownOpen ? 'transform rotate-180' : ''}`} />
       </button>
       {isDropdownOpen && (
           <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
               {voices.map((voice) => (
                   <button
                       key={voice.id}
                       onClick={() => selectOption(voice)}
                       className={`w-full p-2 text-left hover:bg-indigo-100 transition-colors duration-200 flex items-center ${seriesData.voice?.id === voice.id ? 'bg-indigo-100' : ''}`}
                   >
                       <span className="flex-grow">{voice.name}</span>
                       <audio controls className="h-8">
                           <source src={voice.preview} type="audio/mpeg" />
                           Your browser does not support the audio element.
                       </audio>
                   </button>
               ))}
           </div>
       )}
       {/*{isDropdownOpen && (*/}
       {/*    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">*/}
       {/*        {voices.map((voice) => (*/}
       {/*            <button*/}
       {/*                key={voice.id}*/}
       {/*                onClick={() => selectOption(voice.id)}*/}
       {/*                className="w-full p-2 text-left hover:bg-indigo-100 transition-colors duration-200 flex items-center"*/}
       {/*            >*/}
       {/*                <span className="flex-grow">{voice.name}</span>*/}
       {/*                <audio controls className="h-8">*/}
       {/*                    <source src={voice.preview} type="audio/mpeg" />*/}
       {/*                    Your browser does not support the audio element.*/}
       {/*                </audio>*/}
       {/*            </button>*/}
       {/*        ))}*/}
       {/*    </div>*/}
       {/*)}*/}
   </div>
};

export default VoiceDropdown;
